import { PENDING, SUCCESS, ERROR } from '../globalStatuses/globalStatuses';
import systemNotificationsTypes from './systemNotificationsTypes';

const initialState = {
    campaigns: [],
    notification: null,
    loadStatus: '',
    submitStatus: '',
};

const systemNotificationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case systemNotificationsTypes.GET_ACTIVE_CAMPAIGNS_PENDING:
            return { ...state, loadStatus: PENDING };

        case systemNotificationsTypes.GET_ACTIVE_CAMPAIGNS_SUCCESS:
            return {
                ...state,
                campaigns: action.payload,
                notification: null,
                loadStatus: SUCCESS,
            };

        case systemNotificationsTypes.GET_ACTIVE_CAMPAIGNS_ERROR:
            return { ...state, loadStatus: ERROR };

        case systemNotificationsTypes.SET_NOTIFICATION_CONTENT:
            return { ...state, notification: action.payload };

        case systemNotificationsTypes.RESPOND_PENDING:
            return { ...state, submitStatus: PENDING };

        case systemNotificationsTypes.RESPOND_SUCCESS:
            return {
                ...state,
                campaigns: state.campaigns.slice(1),
                notification: null,
                submitStatus: SUCCESS,
            };

        case systemNotificationsTypes.RESPOND_ERROR:
            return { ...state, submitStatus: ERROR };

        default:
            return state;
    }
};

export default systemNotificationsReducer;
